import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationsEN from './en/en.json';
import translationsFR from './fr/fr.json';

const resources = {
  EN: {
    translation: translationsEN,
  },
  FR: {
    translation: translationsFR,
  },
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    fallbackLng: String(localStorage.getItem('lancode'))??"EN",
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
